import browser from "webextension-polyfill";
import { ytHavenToggleState, ytHavenShouldStart, ytHavenRecordEvent, } from "../shared/index.js";
import { abpLogo } from "../img/abp-logo.js";
import { abLogo } from "../img/ab-logo.js";
const iframePlayerId = "yt-haven-embed-player";
export const videoContextStore = {
    _videoContext: null,
    setVideoContext(newContext) {
        this._videoContext = newContext;
    },
    getVideoContext() {
        if (!this._videoContext) {
            throw new Error("Video store was not initialized properly");
        }
        return this._videoContext;
    },
};
export async function isInHavenExperiment() {
    return await browser.runtime.sendMessage({ type: ytHavenShouldStart });
}
export function isWatchPage() {
    const parsedUrl = new URL(window.location.href);
    const { hostname, pathname } = parsedUrl;
    const rightDomain = hostname === "www.youtube.com" || hostname === "youtube.com";
    const rightPath = pathname === "/watch" || pathname.startsWith("/watch/");
    return rightDomain && rightPath;
}
export function getIframePlayer() {
    return document.getElementById(iframePlayerId);
}
export function createIframePlayer(playerConfig) {
    const { videoId, playlistId, showWatchingWith, startSeconds, showInModal = false, } = playerConfig;
    const embedUrl = new URL(`https://www.youtube-nocookie.com/embed/${videoId}`);
    embedUrl.searchParams.set("controls", "1");
    embedUrl.searchParams.set("autoplay", "1");
    embedUrl.searchParams.set("enablejsapi", "1");
    if (startSeconds) {
        embedUrl.searchParams.set("start", startSeconds.toString());
    }
    if (playlistId) {
        embedUrl.searchParams.set("listType", "playlist");
        embedUrl.searchParams.set("list", playlistId);
    }
    if (showWatchingWith) {
        embedUrl.hash = "yt-haven";
    }
    const iframe = document.createElement("iframe");
    iframe.src = embedUrl.toString();
    iframe.id = iframePlayerId;
    iframe.style.border = "0";
    iframe.allow =
        "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
    iframe.allowFullscreen = true;
    iframe.referrerPolicy = "strict-origin-when-cross-origin";
    if (showInModal) {
        iframe.style.width = "50%";
        iframe.style.aspectRatio = "16/9";
        iframe.style.borderRadius = "12px";
    }
    else {
        iframe.style.position = "absolute";
        iframe.style.top = "0";
        iframe.style.left = "0";
        iframe.style.width = "100%";
        iframe.style.height = "100%";
        iframe.style.zIndex = "500";
    }
    iframe.onload = function () {
        setTimeout(() => {
            var _a;
            (_a = iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage('{"event":"listening"}', "*");
        });
    };
    return iframe;
}
export function createLogoSVG() {
    const { short_name: extName } = browser.runtime.getManifest();
    let extLogo = abLogo;
    if (extName === "Adblock Plus") {
        extLogo = abpLogo;
    }
    const logo = document.createElement("div");
    logo.innerHTML = extLogo;
    return logo.firstChild;
}
export const getToggleState = async () => {
    return await browser.runtime.sendMessage({
        type: ytHavenToggleState,
    });
};
export function isDarkMode() {
    const docAttr = document.documentElement.getAttribute("dark");
    const ytdApp = document.querySelector("ytd-app");
    return docAttr !== null || (ytdApp !== null && ytdApp.hasAttribute("dark"));
}
export async function recordEvent(eventName, eventPayload) {
    void browser.runtime.sendMessage({
        type: ytHavenRecordEvent,
        eventName,
        eventPayload,
    });
}
